import { useCreateMediaSource } from 'scenes/Campaigns/GGCampaigns/data/mutations';

import MediaSourceForm from 'scenes/Campaigns/components/MediaSourceForm';

export const CreateMediaSourceForm = (props) => {
  const [createMediaSource, { isLoading: isCreating }] = useCreateMediaSource();
  const handleSubmit = async (values) => {
    const mediaSource = await createMediaSource(values);

    props.onSubmit(mediaSource);
  };
  return (
    <MediaSourceForm
      {...props}
      title={'Add Media Source'}
      onSubmit={handleSubmit}
      loading={isCreating}
    />
  );
};
